import React, { FC } from 'react';
import { Bar } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';
import { CardWrapper } from '../../CardWrapper/CardWrapper';
import styles from './BarChart.module.scss';

const options: ChartOptions<'bar'> = {
	scales: {
		y: {
			beginAtZero: true,
			grid: {
				color: '#ADADAD',
				drawBorder: false,
			},
			ticks: {
				maxTicksLimit: 8,
			},
		},
		x: {
			beginAtZero: true,
			ticks: {
				color: '#ADADAD',
			},
			grid: {
				display: false,
				drawTicks: false,
				drawBorder: false,
			},
		},
	},
	elements: {
		bar: {
			borderWidth: 1,
			borderRadius: 8,
		},
	},
	plugins: {
		legend: {
			display: false,
		},
		tooltip: {
			intersect: false,
		},
	},
};

interface BarChartProps {
	data: ChartData<'bar'>;
	title: string;
	className?: string;
	labelFormater?: (value: string) => string;
}

const BarChart: FC<BarChartProps> = ({ data, title, labelFormater, className = '' }): JSX.Element => {
	const hasData = data.datasets[0]?.data?.some((value) => value);
	const chartOptions = { ...options };
	if (labelFormater && chartOptions?.scales?.x?.ticks) {
		chartOptions.scales.x.ticks.callback = function (val) {
			const label = labelFormater(this.getLabelForValue(val as number));
			return label;
		};
	}

	return (
		<CardWrapper backgroundColor='#1E272E' className={className}>
			<h4 className={styles.Title}>{title}</h4>
			<div className={styles.Content}>
				{!hasData && (
					<div className={styles.NoData}>
						<span>No Data</span>
					</div>
				)}
				<Bar options={chartOptions} data={data} height={150} />
			</div>
		</CardWrapper>
	);
};

export default BarChart;
